export default "__VITE_ASSET__2564eed5__"